// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2MRqG","large":"styles_large__2YH1K"};